import type { UseFormReturn } from 'react-hook-form';
import { Labeled } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import type { IArticleFormValues } from './ArticleForm';
import { FormCheckableDisclosure } from '~/components/atoms/fields/CheckableDisclosure';
import { FormDateField } from '~/components/atoms/fields/DateField';

export type IArticleFormEventSectionProps = IContainerProps & {
  mode: IFormMode;
  form: UseFormReturn<IArticleFormValues>;
};

export const ArticleFormEventSection: React.FC<
  IArticleFormEventSectionProps
> = ({ sx, form }) => {
  const { t } = useTranslation();

  return (
    <FormCheckableDisclosure
      sx={sx}
      label={t('ArticleFormEventSection.title')}
      control={form.control}
      name="isEvent"
      initiallyExpanded={!!form.watch('isEvent')}
    >
      <p>{t('ArticleFormEventSection.description')}</p>
      <Labeled
        label={t('ArticleFormEventSection.field.start-at.label')}
        disabled={!form.watch('isEvent')}
        required
      >
        <FormDateField name="eventStartDate" control={form.control} />
      </Labeled>
      <Labeled
        label={t('ArticleFormEventSection.field.end-at.label')}
        disabled={!form.watch('isEvent')}
        required
      >
        <FormDateField
          name="eventEndDate"
          control={form.control}
          rules={{
            min: form.watch('eventStartDate'),
          }}
        />
      </Labeled>
    </FormCheckableDisclosure>
  );
};
